import { ForecastPaginatedActions } from 'src/features/forecastPaginated/forecastPaginatedActions/ForecastPaginatedActions';
import { ForecastPaginatedActionsSkeleton } from 'src/features/forecastPaginated/forecastPaginatedActions/ForecastPaginatedActionsSkeleton';

type ForecastPaginatedActionsContainerProps = {
  isLoading: boolean;
  hasPrevious: boolean;
  hasNext: boolean;
  sessionId?: string;
  sku?: string | null;
  isDestocking?: boolean;
  totalProducts?: number;
  validatedNumber: number;
  validatedAt?: string | null;
  handlePrevious: () => void;
  handleNext: () => void;
  handleReset: () => void;
};

export function ForecastPaginatedActionsContainer({
  isLoading,
  hasPrevious,
  hasNext,
  sessionId,
  sku,
  isDestocking,
  totalProducts,
  validatedNumber,
  validatedAt,
  handlePrevious,
  handleNext,
  handleReset,
}: ForecastPaginatedActionsContainerProps) {
  return (
    <>
      {totalProducts !== undefined && !isLoading && sku && sessionId ? (
        <ForecastPaginatedActions
          handleNext={handleNext}
          handlePrevious={handlePrevious}
          handleReset={handleReset}
          hasNext={hasNext}
          hasPrevious={hasPrevious}
          isDestocking={isDestocking}
          isLoading={isLoading}
          sessionId={sessionId}
          sku={sku}
          totalProducts={totalProducts}
          validatedAt={validatedAt}
          validatedNumber={validatedNumber}
        />
      ) : (
        <ForecastPaginatedActionsSkeleton />
      )}
    </>
  );
}
